module.exports = __webpack_public_path__ + "static/media/face-care.584cc6cf.webp";